import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loadingDailyHistory: false,
  loadingReviewDailyQuiz: false,
  loadingReviewQualDailyQuiz: false,
  dailyHistory: {
    totalHistoryItems: 0,
    dailyHistoryList: [],
  },

  isQualDailyQuizHistoryLoading: false,
  qualDailyQuizHistory: {
    totalHistoryItems: 0,
    dailyHistoryList: [],
  },
});

const reducer = function dailyQuizHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_DAILY_QUIZ_HISTORY:
      if (action.reset) {
        return state.set('dailyHistory', action.dailyQuizHistory);
      }
      const oldHistory = state.get('dailyHistory');
      oldHistory.totalHistoryItems = action.dailyQuizHistory.totalHistoryItems;
      oldHistory.dailyHistoryList = oldHistory.dailyHistoryList.concat(
        action.dailyQuizHistory.dailyHistoryList,
      );
      oldHistory.dailyInRetakeId = action.dailyQuizHistory.dailyInRetakeId;
      oldHistory.isDailyQuizActive = action.dailyQuizHistory.isDailyQuizActive;
      return state.set('dailyHistory', oldHistory);

    case t.SET_QUAL_DAILY_QUIZ_HISTORY:
      if (action.reset) {
        return state.set('qualDailyQuizHistory', action.dailyQuizHistory);
      }
      const oldQualDailyQuizHistory = state.get('qualDailyQuizHistory');
      oldQualDailyQuizHistory.totalHistoryItems =
        action.dailyQuizHistory.totalHistoryItems;
      oldQualDailyQuizHistory.dailyHistoryList =
        oldQualDailyQuizHistory.dailyHistoryList.concat(
          action.dailyQuizHistory.dailyHistoryList,
        );
      oldQualDailyQuizHistory.qualDailyInRetakeId =
        action.dailyQuizHistory.qualDailyInRetakeId;
      oldQualDailyQuizHistory.isQualDailyQuizActive =
        action.dailyQuizHistory.isQualDailyQuizActive;

      return state.set('qualDailyQuizHistory', oldQualDailyQuizHistory);

    case t.SET_IS_LOADING_DAILY_QUIZ_HISTORY:
      return state.set('loadingDailyHistory', action.isLoadingQuizHistory);

    case t.SET_IS_QUAL_DAILY_QUIZ_HISTORY_LOADING:
      return state.set('isQualDailyQuizHistoryLoading', action.value);

    case t.SET_LOADING_REVIEW_DAILY_QUIZ:
      return state.set('loadingReviewDailyQuiz', action.value);

    case t.SET_LOADING_REVIEW_QUAL_DAILY_QUIZ:
      return state.set('loadingReviewQualDailyQuiz', action.value);

    case t.RESET_DAILY_QUIZ_HISTORY:
      return state.set('dailyHistory', {
        totalHistoryItems: 0,
        dailyHistoryList: [],
      });

    default:
      return state;
  }
};

export default reducer;
